import { useSyncExternalStore } from 'react';

/** `TST` is what Epic calls its test environment. */
export type DataEnvironment = 'prod' | 'tst';

const STORAGE_KEY = 'providerValidator.dataEnvironment';
const listeners = new Set<() => void>();

export function getDataEnvironment(): DataEnvironment {
  return localStorage.getItem(STORAGE_KEY) === 'tst' ? 'tst' : 'prod';
}

export function setDataEnvironment(environment: DataEnvironment): void {
  localStorage.setItem(STORAGE_KEY, environment);
  listeners.forEach((listener) => listener());
  // Reload so every page drops cached results from the previous environment.
  window.location.reload();
}

export function useDataEnvironment(): DataEnvironment {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    getDataEnvironment,
    () => 'prod'
  );
}
